/**
 * Función utilitaria para obtener el nombre display del rol de usuario
 * @param {string} rol - El rol del usuario ('superadmin', 'admin', 'rrhh', 'psicologo')
 * @returns {string} - El nombre amigable del rol
 */
export const getRolDisplay = (rol) => {
  const roles = {
    'superadmin': 'Super Administrador',
    'admin': 'Administrador',
    'rrhh': 'RRHH',
    'psicologo': 'Psicólogo',
    'empleado': 'Empleado'
  };
  return roles[rol] || rol;
};

/**
 * Función para verificar si un email tiene privilegios de superadmin
 * @param {string} email - El email del usuario
 * @returns {boolean} - True si tiene privilegios de superadmin
 */
export const hasSupeRadminPrivileges = (email) => {
  const superadminEmails = [
    "admin@ossinnovation.com",
    "db@ossinnovation.com"
  ];
  return superadminEmails.includes(email);
};
